import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { LinkTranslatedProps } from '@contracts';
import LinkTranslated from './LinkTranslated';

interface Props extends LinkTranslatedProps {
  $color?: string;
  $disabled?: boolean;
  $standard?: boolean;
  $noBottomBorder?: boolean;
}

const TextLink = styled(LinkTranslated)<Props>`
  ${(props) => props.$disabled && `opacity: 0.5; cursor: unset;`}
  border: 0;
  padding: 0 0 0 0;
  background: transparent;
  font-family: BrownStd;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.5px;
  text-align: left;
  color: ${(props: Props) => (props.$color ? props.$color : Colors.forestGreen)};
  border-bottom: 2px solid ${(props: Props) => (props.$color ? props.$color : Colors.forestGreen)};
  cursor: pointer;
  text-decoration: none;

  ${(props) => props.$standard && `border-bottom: none; padding: 0;`}

  ${(props) => props.$noBottomBorder && `border-bottom: none;`}

  &:hover {
    opacity: 0.6;
    text-decoration: none;

    ${(props) => props.$standard && `text-decoration: underline;`}
  }

  @media (max-width: 1024px) {
    letter-spacing: 0;
    text-align: center;
  }
`;

export default TextLink;
